import { FormSelect } from '@/components/forms/FormSelect';
import { MEAL_TYPE_LABELS } from '@/features/meals/constants';

const mealTypeOptions = Object.keys(MEAL_TYPE_LABELS).map((mealType) => ({
  value: mealType,
  label: MEAL_TYPE_LABELS [mealType],
}));

export function FormMealTypePicker({ name = 'meal_type', label = 'Meal Type', sx }) {
  return <FormSelect name={name} label={label} options={mealTypeOptions} sx={sx} />;
}
